// Added the breakpoints we use in css to be able to apply js logic depending on
// viewport width.
// Example: showing/hiding a second save button in the device manager's timer
//          but only show it on mobile if the list of displayed time slots is
//          long. Otherwise the button above and below would be visible which
//          looks weird / like a bug.
const BP_XS = 400
const BP_SSM = 500
const BP_SM = 600
const BP_MD = 768
const BP_ML = 850
const BP_LG = 992
const BP_XL = 1100
const BP_XXL = 1200

const SENSOR_DATA_POWER = 1
const SENSOR_DATA_TEMPERATURE = 3
const SENSOR_DATA_IS_ON = 4

const DEVICE_STATUS_SWITCHED_OFF = 1
const DEVICE_STATUS_SWITCHED_ON = 2
const DEVICE_STATUS_NOT_REACHABLE = 3
const DEVICE_MODE_CHANGED_TO_MEASURE = 4

const DEVICE_TYPE_MYSTROM_WIFI_SWITCH = 'myStrom-Wifi-Switch'

const DEVICE_TYPE_FRONIUS_INVERTER = 'Fronius-Inverter'

export type CubeOrderValue =
  | 'shortestDistanceFirst'
  | 'longestDistanceFirst'
  | 'lowestPriceFirst'
  | 'highestPriceFirst'
  | 'biggestProductionFirst'
  | 'mostLikes'

const CUBE_ORDER = {
  SHORTEST_DISTANCE_FIRST: 'shortestDistanceFirst',
  LONGEST_DISTANCE_FIRST: 'longestDistanceFirst',
  LOWEST_PRICE_FIRST: 'lowestPriceFirst',
  HIGHEST_PRICE_FIRST: 'highestPriceFirst',
  BIGGEST_PRODUCTION_FIRST: 'biggestProductionFirst',
  MOST_LIKES: 'mostLikes'
} as const

export const APP_VERSION = __APP_VERSION__

export const REEM_API_VERSION = 1
export const BACKEND_API_VERSION = '2.3'
export const CUBE_API_VERSION = 2

export const ASSETS_PATH = '/img'

export const WATTAGE_TWEEN_DURATION = 0.8
export const VAT_FACTOR = 1.2

export const MAIN_ROUTE_NAMES = ['home', 'history', 'efriends', 'devices']

export const DOM_RECT_EMPTY = new DOMRect()

export const MIN_ENERGY_TRACE = 0.1 //watts

export const Constants = {
  // extract only the real hostname without subdomains
  HOSTNAME: import.meta.env.VITE_REMOTECUBE_HOSTNAME || new URL(import.meta.env.VITE_APP_URL as string)?.hostname?.split('.')?.slice(-2)?.join('.')
} as const;

export const NOTIFICATION_TYPES_MAP = {
  community: [
    'price_change',
    'consumer_connected',
    'sharing_request',
    'donation_notification',
    'consumer_disconnected',
    'producer_disconnected'
  ],
  invoice: ['service_new_invoice'],
  'meter-read': ['service_cube_not_reachable'],
  devices: []
}

export const CONNECTION_PRIORITIES = [
  {
    title: 'Sehr Hoch',
    // shortTitle: '++',
    value: 'veryhigh'
  },
  {
    title: 'Hoch',
    // shortTitle: '+',
    value: 'high'
  },
  {
    title: 'Standard',
    // shortTitle: '~',
    value: 'default'
  },
  {
    title: 'Niedrig',
    // shortTitle: '-',
    value: 'low'
  },
  {
    title: 'Sehr Niedrig',
    // shortTitle: '--',
    value: 'verylow'
  }
]

export const STATIC__FILES_HOSTNAME: string = import.meta.env.VITE_STATIC__FILES_HOSTNAME as string ?? 'https://static.efriends.at'
export const CUBE_ICON_BASE_PATH = new URL('/app/v2/img/map-icons/efriends/', STATIC__FILES_HOSTNAME).toString()
export const CUBE_CUSTOM_ICON_BASE_PATH = new URL('/custom/', CUBE_ICON_BASE_PATH).toString()
export const EFRIEND_OF_THE_MONTH_URL: string = new URL("/app/v2/img/map-icons/efriends/custom/prod-ef-of-month.svg", STATIC__FILES_HOSTNAME).toString()

export const CHOOSE_PROVIDERS = {
  home: {
    images: [
      {
        media: '(max-width: 767px)',
        url: new URL( '/app/v2/img/screenshots/efriends-map-verbrauch--mobile.png', STATIC__FILES_HOSTNAME).toString
      },
      {
        media: '(min-width: 768px)',
        url: new URL( 'app/v2/img/screenshots/efriends-map-verbrauch--desktop.png', STATIC__FILES_HOSTNAME).toString
      }
    ]
  },
  history: {
    images: [
      {
        media: '(max-width: 767px)',
        url: new URL('/app/v2/img/screenshots/efriends-map-statistiken--mobile.png', STATIC__FILES_HOSTNAME).toString
      },
      {
        media: '(min-width: 768px)',
        url: new URL('/app/v2/img/screenshots/efriends-map-statistiken--desktop.png', STATIC__FILES_HOSTNAME).toString
      }
    ]
  },
  devices: {
    images: [
      {
        media: '(max-width: 767px)',
        url: new URL('/app/v2/img/screenshots/efriends-map-geraete--mobile.png', STATIC__FILES_HOSTNAME).toString
      },
      {
        media: '(min-width: 768px)',
        url: new URL('/app/v2/img/screenshots/efriends-map-geraete--desktop.png', STATIC__FILES_HOSTNAME).toString
      }
    ]
  },
  map: {
    images: [
      {
        media: '(max-width: 767px)',
        url: new URL('/app/v2/img/screenshots/efriends-map-karte--mobile.png', STATIC__FILES_HOSTNAME).toString
      },
      {
        media: '(min-width: 768px)',
        url: new URL('/app/v2/img/screenshots/efriends-map-karte--desktop.png', STATIC__FILES_HOSTNAME).toString
      }
    ]
  }
}

export {
  BP_LG,
  BP_MD,
  BP_ML,
  BP_SM,
  BP_SSM,
  BP_XL,
  BP_XS,
  BP_XXL,
  CUBE_ORDER,
  DEVICE_MODE_CHANGED_TO_MEASURE,
  DEVICE_STATUS_NOT_REACHABLE,
  DEVICE_STATUS_SWITCHED_OFF,
  DEVICE_STATUS_SWITCHED_ON,
  DEVICE_TYPE_FRONIUS_INVERTER,
  DEVICE_TYPE_MYSTROM_WIFI_SWITCH,
  SENSOR_DATA_IS_ON,
  SENSOR_DATA_POWER,
  SENSOR_DATA_TEMPERATURE
}
